import styled from 'styled-components';

const Input = styled.input`
  font-size: 1.25em;
  padding: 0.5em;
  margin: 0.5em;
  color: #fff;
  background: transparent;
  border: 1px solid #fff;
  border-radius: 3px;

  &:hover {
    box-shadow: inset 1px 1px 2px rgba(0,0,0,0.1);
  }
`;

export default Input;



// WEBPACK FOOTER //
// ./src/components/common/Input/index.js